import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { MatTableDataSource } from '@angular/material';
import { AnalyticsChartService } from '../services/analytics/analytics-chart.service';
import { SelectionModel } from '@angular/cdk/collections';
import moment from 'moment';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';
import { FeatureListJsonService } from 'src/app/shared/services/config-manager/feature-list/feature-list-json.service';

@Component({
  selector: 'app-analytics-dialog',
  templateUrl: './analytics-dialog.component.html',
  styleUrls: ['./analytics-dialog.component.scss']
})
export class AnalyticsDialogComponent implements OnInit {
  normalizeData = false;
  endAbTest = {
    step1: true,
    winning_variant: '',
    rollout_percent: 0
  };
  chartLoading;
  dataScheduledForReload = false;
  branchIdBranchNameMap = {};
  resultTableDataLoading;
  step = 'day';
  duration = '3D';
  reportTimeOptions = this.analyticsChartService.getReportTimeOptions();
  selectedTimeOption = this.reportTimeOptions[0];
  selectedEvent;
  journeyData: any;
  node: any;
  splitPercList: any;
  resultTableData = [];
  chartData;
  dataSource = new MatTableDataSource(this.resultTableData);
  selection = new SelectionModel(true, []);
  displayedColumns: string[] = ['branch', 'event_count'];
  public dashboardConfig: any;
  public showBranchId: boolean = false;
  // lineChart
  public lineChartData: Array<any> = [];
  public lineChartLabels: Array<any> = [];
  public lineChartOptions = this.analyticsChartService.getLineChartOptions();
  public lineChartColors = this.analyticsChartService.getLineChartColors();
  // Line chart end
  constructor(
    private dialogRef: MatDialogRef<AnalyticsDialogComponent>,
    private analyticsChartService: AnalyticsChartService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonNotificationService: CommonNotificationService,
    private datacontextService: DatacontextService,
    private featureListJsonService: FeatureListJsonService
  ) { }

  ngOnInit() {
    this.journeyData = this.data.analyticsData;
    this.node = this.data.node;
    if (this.data.node.ab_exp_node) {
      this.splitPercList = JSON.parse(JSON.stringify(this.data.node.ab_exp_node.split));
    }
    this.selectedEvent = this.journeyData.events[0];
    if (this.journeyData.winning_variant) {
      this.endAbTest.step1 = false;
    }
    if (this.selectedEvent && this.selectedEvent.type && this.selectedEvent.type.label) {
      this.setEventType();
    }
    this.endAbTest.rollout_percent = this.journeyData.rollout_percent;
    this.endAbTest.rollout_percent = this.journeyData.winning_variant;
    this.getEventDetails();
    this.getEventTotalCount();
    this.setYAxisLabel();
    this.dashboardConfig = this.featureListJsonService.returnTheConfig();
    this.featureListJsonService.shouldEnableTheFeature('interaction_maps.results.show_branch_ids', true, flag => this.showBranchId = flag);
  }

  public setEventType() {
    switch (this.selectedEvent.type.label) {
      case 'generic':
        this.displayedColumns = ['branch', 'unique_user_count', 'event_count'];
        break;
      case 'conversion':
        this.displayedColumns = ['branch', 'unique_user_count', 'conversions', 'event_count'];
        break;
      case 'revenue':
        this.displayedColumns = ['branch', 'unique_user_count', 'total_revenue', 'event_count'];
        break;
      case 'sum':
        this.displayedColumns = ['branch', 'unique_user_count', 'sum', 'event_count'];
        break;
      default:
        break;
    }
  }

  public showDataReloadBtn() {
    const lst = moment.unix(this.chartData[0].lst);
    const lut = moment.unix(this.chartData[0].lut);
    const cts = moment.unix(moment(moment().valueOf()).valueOf()).add(2, 'hour');
    if (lst.diff(lut) > 0 || lut.diff(cts) > 0 || this.dataScheduledForReload) {
      return false;
    }
    return true;
  }

  public reloadAnalyticsData() {
    this.datacontextService.analytics.scheduleAnalyticsRefresh(undefined, this.journeyData.journey_id)
      .subscribe((data: any) => {
        if (!data.is_error) {
          this.dataScheduledForReload = true;
          this.commonNotificationService.showSnackBar('Journey data has been scheduled for refresh', 'success', 2000);
        }
      });
  }

  public getFormattedTS() {
    return moment.unix(this.chartData[0].lut).fromNow();
  }

  getEventDetails() {
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    this.chartLoading = true;
    const branchIdList = this.journeyData.branches.map(function (branch) {
      return branch.branch_id;
    });
    return this.datacontextService.analytics.getEventDetails(
      this.selectedEvent.analytics_id,
      this.journeyData.journey_id,
      this.normalizeData,
      branchIdList,
      this.step,
      time.start.valueOf(),
      time.end.valueOf()
    ).subscribe((data: any) => {
      if (data.is_error) {
        return;
      }
      this.chartData = data.api_response.data;
      this.activate();
      this.chartLoading = false;
    }, (err) => {
    });
  }

  getEventTotalCount() {
    this.resultTableDataLoading = true;
    const branchIdList = this.journeyData.branches.map(function (branch) {
      return branch.branch_id;
    });
    return this.datacontextService.analytics.getEventTotalCount(
      this.selectedEvent.analytics_id,
      this.journeyData.journey_id,
      branchIdList
    ).subscribe((data: any) => {
      if (data.is_error) {
        return;
      }
      this.populateResultTableData(data.api_response.data);
      this.resultTableDataLoading = false;
    }, (err) => {
    });
  }

  populateResultTableData(data) {
    const branchIdList = this.journeyData.branches.map(function (branch) {
      return branch.branch_id;
    });
    const tableData = [];
    for (let i = 0; i < branchIdList.length; i++) {
      tableData.push({ branch_id: branchIdList[i], vc: 0, tc: 0, uc: 0, sum: 0 });
    }
    for (let i = 0; i < tableData.length; i++) {
      for (let j = 0; j < data.length; j++) {
        if (tableData[i].branch_id === data[j].branch_id) {
          tableData[i] = data[j];
        }
      }
    }
    this.resultTableData = tableData;
    this.dataSource = new MatTableDataSource(this.resultTableData);
    this.selection = new SelectionModel(true, []);
  }

  activate() {
    const time = this.analyticsChartService.getStartAndEndTime(this.step, this.duration);
    const xAxis = this.analyticsChartService.generateX(time.start, time.end, this.step);
    this.lineChartLabels.length = 0;
    this.lineChartData = [];
    for (let i = 0; i < xAxis.length; i++) {
      this.lineChartLabels.push(xAxis[i]);
    }
    for (let i = 0; i < this.journeyData.branches.length; i++) {
      this.journeyData.branches[i].idx = i;
    }
    this.journeyData.branches.sort(function (a, b) {
      if (a.not_in_node) {
        return 1;
      }
      return -1;
    });
    for (let i = 0; i < this.journeyData.branches.length; i++) {
      this.branchIdBranchNameMap[this.journeyData.branches[i].branch_id] = this.journeyData.branches[i].branch_name;
      this.lineChartData.push({
        data: this.populateData(this.journeyData.branches[i].branch_id, this.lineChartLabels, this.normalizeData),
        label: this.journeyData.branches[i].branch_name,
        fill: false,
        borderWidth: 1.5,
        borderDash: this.journeyData.branches[i].not_in_node ? [10, 5] : [0, 0]
      });
    }
  }

  populateData(branchId, timeLine, normalizeData) {
    const yValue = timeLine.map(function (x) {
      return 0;
    });
    const branchData = this.chartData.find(function (element) {
      return element.branch_id === branchId;
    });
    let countKey = 'tc';
    if (
      this.selectedEvent &&
      this.selectedEvent.type &&
      (this.selectedEvent.type.label === 'sum' || this.selectedEvent.type.label === 'revenue')
    ) {
      countKey = 'sum';
    }
    if (
      this.selectedEvent &&
      this.selectedEvent.type &&
      (this.selectedEvent.type.label === 'conversion')
    ) {
      countKey = 'uc';
    }
    if (branchData) {
      branchData.t.forEach(function (dx, idx) {
        if (timeLine.indexOf(dx) >= 0) {
          if (normalizeData) {
            if (branchData.nd[idx]) {
              yValue[timeLine.indexOf(dx)] = branchData[countKey][idx] / branchData.nd[idx];
            }
          } else {
            yValue[timeLine.indexOf(dx)] = branchData[countKey][idx];
          }
        }
      });
    }
    return yValue;
  }

  populateBranchData(branchId) {
    this.chartData.find(function (element) {
      return element.branch_id === branchId;
    });
  }

  onTimeOptionChange() {
    this.step = this.selectedTimeOption.step;
    this.duration = this.selectedTimeOption.duration;
    this.getEventDetails();
  }

  onNormalizationChange() {
    this.getEventDetails();
  }

  onEventChange() {
    this.getEventDetails();
    this.getEventTotalCount();
    this.setYAxisLabel();
    this.setEventType();
  }

  getNodeName(nodeType) {
    if (this.journeyData['branches'] && this.journeyData['branches'].length === 1) {
      return 'Branch';
    }
    switch (nodeType) {
      case 'action_node': {
        return 'Action';
      }
      case 'decision_node': {
        return 'Decision Split';
      }
      case 'rollout_node': {
        return 'Rollout';
      }
      case 'ab_exp_node': {
        return 'A/B Test';
      }
      default: {
        return '';
      }
    }
  }

  /**
   * Whether the number of selected elements matches the total number of rows
   *
   * @return  boolean
   */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * Selects all rows if they are not all selected; otherwise clear selection
   */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  finishExperiment() {
    const val = {
      winning_variant: this.endAbTest.winning_variant,
      rollout_percent: this.endAbTest.rollout_percent
    };
    this.dialogRef.close(val);
  }

  filterBranches(branches: any[]) {
    return branches.filter(branch => !branch.not_in_node && branch.branch_name !== 'Default');
  }

  /**
   * This method check if value present in any of the event property
   */
  ifAnyPropValueExist(rules) {
    for (let i = 0, l = rules.length; i < l; i++) {
      if (rules[i].value || rules[i].value === 0 || rules[i].value === false) {
        return true;
      }
    }
    return false;
  }

  setYAxisLabel() {
    this.lineChartOptions['scales']['yAxes'][0]['scaleLabel']['labelString'] = this.selectedEvent.name;
  }

}
